<fieldset [ngClass]="fieldsetClasses">
  <legend class="legend">{{ inputLabel | translate }}</legend>

  <ng-container *ngIf="leadingIconSrc || leadingIconName">
    <ion-icon
      class="bioicon"
      [src]="leadingIconSrc"
      [name]="leadingIconName"
      (click)="onLeadingIconClick()"
    ></ion-icon>
  </ng-container>

  <ng-container [ngSwitch]="type">
    <ng-container *ngSwitchCase="'textarea'">
      <!-- [type]="internalInputType" -->
      <textarea
        [attr.id]="inputId"
        [value]="currentValue" (input)="onInputChange($event)"
        [attr.inputmode]="inputMode"
        class="inner-input-area"
        [placeholder]="placeholder | translate"
        [attr.maxlength]="maxLength"
        (focus)="onFocus()"
        (blur)="onBlur()"
        [ngClass]="focusClass"
        [attr.autocomplete]="autocomplete"
        [readonly]="readOnly"
        rows="5" 
    cols="50" 
      ></textarea>
    </ng-container>
    <ng-container *ngSwitchCase="'text'">
      <input
        [attr.id]="inputId"
        [type]="internalInputType"
        [value]="currentValue" (input)="onInputChange($event)"
        [attr.inputmode]="inputMode"
        class="inner-input"
        [placeholder]="placeholder | translate"
        [attr.maxlength]="maxLength"
        (focus)="onFocus()"
        (blur)="onBlur()"
        [ngClass]="focusClass"
        [attr.autocomplete]="autocomplete"
        [readonly]="readOnly"
      />
    </ng-container>
    <ng-container *ngSwitchCase="'password'">
      <input
        [type]="internalInputType"
        [value]="currentValue"
        (input)="onInputChange($event)"
        [attr.inputmode]="inputMode"
        class="inner-input"
        [placeholder]="placeholder | translate"
        [attr.maxlength]="maxLength"
        (focus)="onFocus()"
        (blur)="onBlur()"
        [ngClass]="focusClass"
        [attr.autocomplete]="autocomplete"
        [readonly]="readOnly"
      />
    </ng-container>
    <ng-container *ngSwitchCase="'tel'">
      <input
        [type]="internalInputType"
        [value]="currentValue"
        (input)="onInputChange($event)"
        [attr.inputmode]="inputMode"
        class="inner-input"
        [placeholder]="placeholder | translate"
        [attr.maxlength]="maxLength"
        (focus)="onFocus()"
        (blur)="onBlur()"
        [ngClass]="focusClass"
        [attr.autocomplete]="autocomplete"
        [readonly]="readOnly"
      />
    </ng-container>
    <ng-container *ngSwitchCase="'email'">
      <input
        [type]="internalInputType"
        [value]="currentValue"
        (input)="onInputChange($event)"
        [attr.inputmode]="inputMode"
        class="inner-input"
        [placeholder]="placeholder | translate"
        [attr.maxlength]="maxLength"
        (focus)="onFocus()"
        (blur)="onBlur()"
        [ngClass]="focusClass"
        [attr.autocomplete]="autocomplete"
        [readonly]="readOnly"
      />
    </ng-container>

    <ng-container *ngSwitchCase="'select'">
      <ion-select
        class="inner-input"
        [value]="currentValue" (ionChange)="onSelectChange($event)"
        [placeholder]="placeholder | translate"
        interface="action-sheet"
        [attr.name]="controlName"
      >
        <ion-select-option *ngFor="let option of selectOptions" [value]="option.id">
          {{ option.name }}
          <ng-container *ngIf="option.delivery_start_time">
            {{option.delivery_start_time}} to {{option.delivery_end_time}}
          </ng-container>
        </ion-select-option>
      </ion-select>
      <ion-icon *ngIf="showDropdownArrow" name="chevron-down-outline" class="dropdown-arrow"></ion-icon>
    </ng-container>

    <ng-container *ngSwitchCase="'area-modal'">
      <ion-input
        class="inner-input"
        [value]="displayValue" readonly
        (click)="onAreaModalClick()"
        [placeholder]="placeholder | translate"
      ></ion-input>
      <ion-icon *ngIf="showDropdownArrow" name="chevron-down-outline" class="dropdown-arrow"></ion-icon>
    </ng-container>

    <ng-container *ngSwitchDefault>
      <input
        [type]="internalInputType"
        [value]="currentValue"
        (input)="onInputChange($event)"
        [attr.inputmode]="inputMode"
        class="inner-input"
        [placeholder]="placeholder | translate"
        [attr.maxlength]="maxLength"
        (focus)="onFocus()"
        (blur)="onBlur()"
        [ngClass]="focusClass"
        [attr.autocomplete]="autocomplete"
        [readonly]="readOnly"
      />
    </ng-container>

  </ng-container>

  <ng-container *ngIf="showPasswordToggle">
    <ion-icon
      (click)="onTogglePasswordVisibility()"
      class="eye-pwd"
      [name]="passwordVisible ? 'eye-outline' : 'eye-off-outline'"
    ></ion-icon>
  </ng-container>
</fieldset>